import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useUtils } from './useUtils';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getDisplayDate } from '../../_helpers/text-field-helper';
import { usePickerState } from './usePickerState';
function parseInputString(value, utils, format) {
  try {
    return utils.parse(value, format);
  } catch (_unused) {
    return null;
  }
}
export function useKeyboardPickerState(props, options) {
  var _props$format = props.format,
    format = _props$format === void 0 ? options.getDefaultFormat() : _props$format,
    inputValue = props.inputValue,
    _onChange = props.onChange,
    value = props.value;
  var utils = useUtils();
  var displayDate = getDisplayDate(value, format, utils, value === null, props);
  var _useState = useState(displayDate),
    _useState2 = _slicedToArray(_useState, 2),
    innerInputValue = _useState2[0],
    setInnerInputValue = _useState2[1];
  var dateValue = inputValue ? parseInputString(inputValue, utils, format) : value;
  useEffect(function () {
    if (value === null || utils.isValid(value)) {
      setInnerInputValue(displayDate);
    }
  }, [displayDate, setInnerInputValue, utils, value]);
  var handleKeyboardChange = useCallback(function (date) {
    _onChange(date, date === null ? null : utils.format(date, format));
  }, [format, _onChange, utils]);
  var _usePickerState = usePickerState(
    // Extend props interface
    _extends({}, props, {
      value: dateValue,
      onChange: handleKeyboardChange
    }), options),
    innerInputProps = _usePickerState.inputProps,
    wrapperProps = _usePickerState.wrapperProps,
    pickerProps = _usePickerState.pickerProps;
  var inputProps = useMemo(function () {
    return _extends({}, innerInputProps, {
      // reuse validation and open/close logic
      format: wrapperProps.format,
      inputValue: inputValue || innerInputValue,
      onChange: function onChange(value) {
        setInnerInputValue(value || '');
        var date = value === null ? null : utils.parse(value, wrapperProps.format);
        _onChange(date, value);
      }
    });
  }, [innerInputProps, innerInputValue, inputValue, _onChange, utils, wrapperProps.format]);
  return {
    inputProps: inputProps,
    wrapperProps: wrapperProps,
    pickerProps: pickerProps
  };
}